$(document).ready(function(){
  var cycler;
  // $('#slideshow').cycle({
  //     fx: 'fade',
  //     pager:  '#controls',
  //     pagerAnchorBuilder: function(idx, slide) {
  //       return '<a class="circle" href="#"></a>';
  //     }
  //   });
  $('#product-images').cycle({
    fx: 'fade',
    pager:  '#controls',
    pause: 1,
    pagerAnchorBuilder: function(idx, slide) {
      return '<a class="thumbnail" href="#">' + slide.innerHTML + '</a>';
    },
    after: function(el, next_el) {
        $(next_el).addClass('active');
        productWrapperHeight();
    },
    before: function(el) {
        $(el).removeClass('active');
        productWrapperHeight();
    }
  });

  $('#product-images').cycle('pause');
  $('a.button-search').click(function(e){
    e.preventDefault();
    $('#header-search').submit();
  })
  if ($('body').attr('class') == "templateIndex") {
    getFBPost();
    cycler = setInterval('cycleSlide()', 5000);
  }

  // Match height to children
  function productWrapperHeight() {
    $('#product-images').each(function(){
      $(this).css('height', $('.product-image.active', this).outerHeight());
    });
  }

  productWrapperHeight();

  $('a.thumbnail').click(function(){
    var newId = $(this).attr('id')
    var chosenEl = newId.replace('c','s');
    cycleSlide(chosenEl);
    activateButton(newId);

    if (cycler) {
      clearInterval(cycler)
      cycler = null;
    }
  });
});
function activateButton(which) {
  $('a.circle.current').removeClass("current");
  $('a#'+which).addClass('current');
}
function cycleSlide(id){
  id = id || "next"
  var active = $('#slideshow .slide.active');
  var $next;
  if (id == "next") {
    $next = ($(active).next().length > 0 && $(active).next().attr('id') != "controls") ? $(active).next() : $('div#s1');
  } else {
    $next = $("div#"+id);
  }
  activateButton($next.attr('id').replace('s','c'))
  $next.css({'z-index':2,'visibility':'visible'});//move the next image up the pile
  $(active).fadeOut(1000,function(){//fade out the top image
    $(active).css('z-index',1).show().removeClass('active');//reset the z-index and unhide the image
    $next.css('z-index',3).addClass('active');//make the next image the top one
  });
}

function tweetReceived(data) {
  $('#tweet_text').html(data[0].text);
  $('#twitter-updated_at').html(relative_time(data[0].created_at));
}

function getFBPost() {
  var url = "https://graph.facebook.com/GreenTreeGardenSupply/feed/?access_token=383310175033833|49uEmfqCKPhS77N2eV3nbHrvgbE&callback=?"
  $.getJSON(url,function(json){
    var created_time = fuzzyFacebookTime(json.data[0].created_time.replace(/-/g,'/'));
    $('#fb_text').html(json.data[0].message);
    $('#facebook-updated_at').html(created_time);
  });

}

function relative_time(time_value) {
  var values = time_value.split(" ");
  time_value = values[1] + " " + values[2] + ", " + values[5] + " " + values[3];
  var parsed_date = Date.parse(time_value);
  var relative_to = (arguments.length > 1) ? arguments[1] : new Date();
  var delta = parseInt((relative_to.getTime() - parsed_date) / 1000);
  delta = delta + (relative_to.getTimezoneOffset() * 60);

  if (delta < 60) {
    return 'less than a minute ago';
  } else if(delta < 120) {
    return 'about a minute ago';
  } else if(delta < (60*60)) {
    return (parseInt(delta / 60)).toString() + ' minutes ago';
  } else if(delta < (120*60)) {
    return 'about an hour ago';
  } else if(delta < (24*60*60)) {
    return 'about ' + (parseInt(delta / 3600)).toString() + ' hours ago';
  } else if(delta < (48*60*60)) {
    return '1 day ago';
  } else {
    return (parseInt(delta / 86400)).toString() + ' days ago';
  }
}
var fuzzyFacebookTime = (function(){

  fuzzyTime.defaultOptions={
    // time display options
    relativeTime : 48,
    // language options
    monthNames : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    amPm : ['AM', 'PM'],
    ordinalSuffix : function(n) {return ['th','st','nd','rd'][n<4 || (n>20 && n % 10<4) ? n % 10 : 0]}
  }

  function fuzzyTime (timeValue, options) {

    var options=options||fuzzyTime.defaultOptions,
        date=parseDate(timeValue),
        delta=parseInt(((new Date()).getTime()-date.getTime())/1000),
        relative=options.relativeTime,
        cutoff=+relative===relative ? relative*60*60 : Infinity;

    if (relative===false || delta>cutoff)
      return formatTime(date, options)+' '+formatDate(date, options);

    if (delta<60) return 'less than a minute ago';
    var minutes=parseInt(delta/60 +0.5);
    if (minutes <= 1) return 'about a minute ago';
    var hours=parseInt(minutes/60 +0.5);
    if (hours<1) return minutes+' minutes ago';
    if (hours==1) return 'about an hour ago';
    var days=parseInt(hours/24 +0.5);
    if (days<1) return hours+' hours ago';
    if (days==1) return formatTime(date, options)+' yesterday';
    var weeks=parseInt(days/7 +0.5);
    if (weeks<2) return formatTime(date, options)+' '+days+' days ago';
    var months=parseInt(weeks/4.34812141 +0.5);
    if (months<2) return weeks+' weeks ago';
    var years=parseInt(months/12 +0.5);
    if (years<2) return months+' months ago';
    return years+' years ago';
  }

  function parseDate (str) {
    var v=str.replace(/[T\+]/g,' ').split(' ');
    return new Date(Date.parse(v[0] + " " + v[1] + " UTC"));
  }

  function formatTime (date, options) {
    var h=date.getHours(), m=''+date.getMinutes(), am=options.amPm;
    return (h>12 ? h-12 : h)+':'+(m.length==1 ? '0' : '' )+m+' '+(h<12 ? am[0] : am[1]);
  }

  function formatDate (date, options) {
    var mon=options.monthNames[date.getMonth()],
        day=date.getDate(),
        year=date.getFullYear(),
        thisyear=(new Date()).getFullYear(),
        suf=options.ordinalSuffix(day);

    return mon+' '+day+suf+(thisyear!=year ? ', '+year : '');
  }

  return fuzzyTime;

}());